"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getSeoFriendlyCategoryName_1 = __importDefault(require("./getSeoFriendlyCategoryName"));
const getCategoryProperty = ({ categories }) => {
    const defaultCategories = { l1: { id: -1 }, l2: { id: -1 }, c: { id: -1 } };
    const result = { ...defaultCategories, ...categories };
    const sfc = (0, getSeoFriendlyCategoryName_1.default)(result.l1);
    return { ...result, sfc };
};
exports.default = getCategoryProperty;
//# sourceMappingURL=getCategoryProperty.js.map